<span>
  I confirm that I have read and agree to the
  <a href="/privacy-policy/" class="cursor-pointer underline"> Privacy Policy </a>
  and
  <a href="/terms-of-use/" class="cursor-pointer text-nowrap underline"> Terms of Use </a>.
</span>
